import { render, staticRenderFns } from "./GroupPhotoApprove.vue?vue&type=template&id=1a522c30"
import script from "./GroupPhotoApprove.vue?vue&type=script&lang=js"
export * from "./GroupPhotoApprove.vue?vue&type=script&lang=js"
import style0 from "./GroupPhotoApprove.vue?vue&type=style&index=0&id=1a522c30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports